import * as SimpleBar from 'simplebar';

import FlatsPage from './flats-page';

import toggleLocales from './toggle-locales';
import initRanges, {
  clearRanges
} from './renderRanges';
import toggleSortPanel from './toggle-sort-panel';
import modalFlatsPlans from './modal-flats-list-plans';
import modalPanorama from './modal-panorama';
import modal3dTour from './modal-3d';
import modalVideo from './modal-video';
import {youtubeLinkToEmbed} from './utils';
import {
  renderOptions,
  renderResultList
} from './get-flats-layout';
import {
  PageName,
  DataSource,
  RangeInitialValues
} from './constants';

const classNames = {
  list: {
    options: `flatography-result__options`,
    content: `flatography-result__content`,
    contentVisible: `flatography-result__content--visible`,
    itemsWrap: `flatography-result__list`
  }
};


export default class FlatsListPage extends FlatsPage {
  constructor() {
    super();
    this.results = this.page.querySelector(`#flats-list`);
    this.form = this.page.querySelector(`.flatography-filters`);
    this.radio = [...this.form.querySelectorAll(`input[type="radio"]`)];
    this.clearButton = this.form.querySelector(`.flatography-filters__clear`);
    this.content = null;
    this.filteredData = [];
    this.filters = {
      ...RangeInitialValues
    };
    this.panorama = "";
  };

  init = (locale) => {
    super.init(locale);
    modalFlatsPlans.init(locale);
    this.loadData(DataSource.FLATS_LIST, (data) => {
      this.setFiltersValues();
      this.renderList();
      this.filteredData = data;
    });
    initRanges(PageName.FLATS, this.saveRangeFilters);
    toggleLocales();
    this.bindHandlers();
  };

  setFiltersValues = () => {
    const filterFromSearch = document.location.search;
    const filtersPatterns = [
      `loft`,
      `istoricheskie-kvartiry`,
      `white-box`
    ];
    const filter = filtersPatterns.find(str => filterFromSearch.indexOf(str) !== -1);

    if (filter) {
      this.filters = {
        ...RangeInitialValues,
        type: filter
      };
      this.radio.find(radio => radio.value === filter).checked = true;
    }
  };

  getResultOptions = (data) => {
    const optionsWrap = document.createElement(`div`);
    const options = renderOptions(data.length, this.locale);

    optionsWrap.className = classNames.list.options;
    optionsWrap.innerHTML = options;

    return optionsWrap;
  };

  getResultsList = (data) => {
    const contentWrap = document.createElement(`div`);
    const listWrap = document.createElement(`ul`);
    const list = renderResultList(data, this.locale);

    contentWrap.className = classNames.list.content;
    listWrap.className = classNames.list.itemsWrap;

    listWrap.innerHTML = list;
    contentWrap.appendChild(listWrap);
    this.content = contentWrap;
    this.setPlanHandler();

    const links = this.content.querySelectorAll('.flat-card__links-cont .link:not(.flat-card__plan)');
    const links3d = this.content.querySelectorAll('.flat-card__3d-link');

    links.forEach(l => l.addEventListener('click', e => e.stopPropagation()));

    modal3dTour.init(links3d);
    return contentWrap;
  };

  setPlanHandler() {
    //Link is represented as div because of w3c validator, so we have to trigger navigation to another page manually
    const links = [...this.content.querySelectorAll(`.flat-card__link`)];

    links.forEach(link => link.addEventListener(`click`, ({
      target,
      currentTarget
    }) => {
      const dataHref = currentTarget.dataset.href;

      if (target.classList.contains(`flat-card__plan`)) {
        const data = this.filteredData.find(item => item["apt_number"] === currentTarget.dataset.number);

        modalFlatsPlans.createContent(data);

        return;
      }

      window.location.href = dataHref;
    }));
  };

  setPanoramaHandler() {

    modalPanorama.init({
      container: () => document.querySelector('div.panorama'),
      wrapperClass: '.flatography-result__list',
      itemClass: '.flat-card__panorama-link',
      onShow: (event, _pano) => {
        return event.currentTarget.dataset.panoramaImg;
      }
    });
  }

  setVideoHandler() {
    const videos = document.querySelectorAll(`.js-modal-video`);

    if (!videos.length)
      return;

    videos.forEach(video => {
      video.addEventListener(`click`, () => {
        $('.modal-video iframe').attr('src', youtubeLinkToEmbed(video.dataset.video));
      });
    });

    modalVideo.init();
    modalVideo.toggle = videos;
    modalVideo.bindHandlers();
  }

  appendList = (data) => {
    const fragment = document.createDocumentFragment();
    const options = this.getResultOptions(data);
    const resultList = this.getResultsList(data);
    this.results.innerHTML = ``;

    fragment.appendChild(options);
    fragment.appendChild(resultList);

    this.results.appendChild(fragment);
    toggleSortPanel(this.results, this.sortList);

    if (!this.isMobile) {
      new SimpleBar(this.content);
    }
  };

  renderList() {
    const filteredItems = this.filterList();

    this.filteredData = filteredItems;
    this.appendList(filteredItems);
    this.setPanoramaHandler();
    this.setVideoHandler();

    if (this.isMobile) {
      this.content.classList.add(classNames.list.contentVisible);
    }
  };

  saveRangeFilters = (filterName, filterValue) => {
    this.filters[filterName] = filterValue;
  };

  saveTypeFilters = ({
    target
  }) => {
    this.filters.type = target.value;
  };

  onFormSubmit = (e) => {
    e.preventDefault();

    this.renderList();
  };

  filterList() {
    return this.data.filter((flat) => {
      const {
        square,
        floor: floors,
        bedrooms,
        flat_type: type
      } = flat;
      const isInRange = (num, range) => {
        return range[0] <= num && num <= range[1];
      };
      const selectedType = this.filters.type ? this.filters.type : type;
      const checkFloors = (floorsArr) => {
        return floorsArr.some(floor => isInRange(floor[0], this.filters.floor));
      };

      return isInRange(square, this.filters.square) &&
        checkFloors(floors) &&
        isInRange(bedrooms, this.filters.rooms) &&
        type === selectedType
    });
  }

  sortList = (param) => {
    const sortedData = this.filteredData.sort((a, b) => {
      if (param === `floor`) return a[param].length < b[param].length ? -1 : 1;

      return a[param] < b[param] ? -1 : 1;
    });
    const sortedResults = renderResultList(sortedData, this.locale);
    const list = this.content.querySelector(`.flatography-result__list`);

    list.innerHTML = ``;
    list.innerHTML = sortedResults;
  };

  clearFilters = () => {
    this.radio.forEach(button => button.checked = false);
    clearRanges(PageName.FLATS);
    this.filters = {
      ...RangeInitialValues
    };
    this.renderList();
  };

  bindHandlers() {
    this.form.addEventListener(`submit`, this.onFormSubmit);
    this.radio.forEach(button => button.addEventListener(`change`, this.saveTypeFilters));
    this.clearButton.addEventListener(`click`, this.clearFilters);
  };
};
